import { render, staticRenderFns } from "./CmgOrderConfirmationPage.vue?vue&type=template&id=687e3c6a&scoped=true&lang=pug"
import script from "./cmg-order-confirmation-page.ts?vue&type=script&lang=ts&external"
export * from "./cmg-order-confirmation-page.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687e3c6a",
  null
  
)

export default component.exports